<template>
  <family-page-wrapper class="about-gogo">
    <h2 class="mb-0">
      Frequently Asked Questions
    </h2>
    <br>
    <div class="help-item">
      <p><b>What’s GoGoGrandparent?</b></p>
      <p>
        That’s us! We’re a fast, affordable and convenient transportation solution for folks that want to safely maintain their
        independence.
      </p>
    </div>
    <div class="help-item">
      <p><b>What do I need?</b></p>
      <p>
        You need a touch tone telephone that can call
        <b>+1 (855) 464-6872</b>. We highly recommend riders have a cell phone so they can always be reached.
      </p>
    </div>
    <div class="help-item">
      <p><b>Are walkers and wheelchairs okay?</b></p>
      <p>
        Walkers and foldable wheelchairs are no problem, as long as you can transfer yourself into a car without assistance. We can check
        with drivers to insure they're comfortable meeting that request. Let any operator know and they’ll add the appropriate notation to
        your account. Whenever driver's are asked to lift something it's customary and appropriate to offer a tip.
      </p>
    </div>
    <div class="help-item">
      <p><b>Who are the drivers?</b></p>
      <p>
        We work with on demand transportation services like Lyft to ensure that you can get affordable rides within 15 minutes. GoGo
        operators communicate, screen and monitor rides to make sure every ride completes safely and successfully.
      </p>
    </div>
    <div class="help-item">
      <p><b>What does "communicate, screen and monitor rides" mean?</b></p>
      <p>
        Within 30 seconds of a trip being accepted by a driver, GoGoGrandparent checks to see if their car is too big for someone with
        ambulatory ailments or if the driver has previously been unwilling to work with older adults. Once a suitable match has been found
        we will issue a series of communications to the driver through their app, through text messages and by calling them to set their
        expectations and insure they are comfortable working with our caller. We have special scenarios for folks with visual impairments
        and ambulatory equipment. Once a driver has been found, we watch the trip and intercept lost drivers, malfunctioning GPS's or
        driver's that for various reasons had to cancel. Once a trip is in progress we handle setting and whenever necessary changing trip
        destinations for passengers that are planning a multi stop trip. We proactively reach out whenever we find a driver going off the
        expected route. Once the trip completes we send confirmation messages to all authorized family and friends and follow up with the
        caller to insure the trip completed safely &amp; successfully. We have developed this process slowly after doing tens of thousands
        of rides and are still tweaking it as we discover new ways to improve the experience for our callers.
      </p>
    </div>
    <div class="help-item">
      <p><b>When should I speak with an operator?</b></p>
      <p>
        Operators are available 24/7 to give quotes, schedule rides in advance and answer any questions that you have. Call and
        <b>Press 0</b> to speak with an operator.
      </p>
    </div>
    <div class="help-item">
      <p><b>Can I cancel my ride?</b></p>
      <p>
        To cancel a ride,
        <b>call us and Press 9</b>. Cancel within 2 minutes of ordering to avoid a fee.
      </p>
    </div>
    <div class="help-item">
      <p><b>How much does it cost?</b></p>
      <p>We charge a small concierge fee plus the vendor’s fare.</p>
      <p>
        Our partners’ rates can change based on the zip code of the pick up address and when demand is high (this happens rarely and returns
        to normal in a few minutes). We quote you the fare every time you call. The driver will not know the total cost of the trip.
      </p>
    </div>
    <div class="help-item">
      <p><b>How do I pay?</b></p>
      <p>
        You do not pay the driver. After the trip, we’ll charge the card you have on file and call or email you with how much was charged.
      </p>
      <p>PLEASE DO NOT PAY IN CASH.</p>
    </div>
    <div class="help-item">
      <p><b>Who do I give my destination to?</b></p>
      <p>
        Usually the driver, but if their equipment is giving them trouble
        <b>Press 0</b> to give it to an operator.
      </p>
      <b><i>
        If you ordered through the automated system, usually the driver. If you ordered through an operator, you will provide it to them.
      </i></b>
    </div>
    <div class="help-item">
      <p><b>Who is GoGoGrandparent for?</b></p>
      <p>
        Our rides are for independent adults who want to maintain their lifestyle. Some members use us to reduce the amount &amp; type of
        driving they do (such as driving at night or going unfamiliar places), while others use us as their complete car replacement.
        Everyone enjoys the convenience of having affordable transportation on-call.
      </p>
    </div>
    <div class="help-item">
      <p><b>How do I register?</b></p>
      <p>
        Get ready for your first ride by registering for free at
        <b>gogograndparent.com</b>
        or by calling us toll-free at
        <b>1 (855) 464-6872</b> and <b>Press 2.</b>
      </p>
    </div>
    <div class="help-item">
      <p><b>How long will I have to wait for my ride?</b></p>
      <p>
        Driver availability depends on your location, the time of day, and number of other rides being requested. In the majority of cases,
        your ride will arrive within 15 minutes -- so be ready to leave when you call!
      </p>
    </div>
    <div class="help-item">
      <p><b>Can I schedule a ride in advance?</b></p>
      <p>
        Yes, but most folks call us 15 minutes before they need to leave. We highly recommend you do the same. That being said to schedule a
        trip in advance <b>Press 0 </b>to speak with an operator.
      </p>
    </div>
    <div class="help-item">
      <p><b>Why are rides more expensive during peak demand?</b></p>
      <p>
        Our vendors fares may change to encourage more drivers to come onto the road. This change is calculated automatically based on how
        many requests were made in a specific location in the prior two minutes. Peak demand is recalculated rapidly, so usually by waiting
        just 5 - 10 minutes, it’ll go away.
      </p>
    </div>
    <div class="help-item">
      <p><b>Can someone else ride with me?</b></p>
      <p>Yes! Up to four people can share one car at no extra charge.</p>
    </div>
    <div class="help-item">
      <p><b>Will the driver wait while I complete my appointment?</b></p>
      <p>
        You may ask your driver to wait but you will be charged for the time. To keep your ride affordable it’s best to give us a call when
        you’re ready to return and
        <b>Press 2</b> for a car to the last place you were dropped off. We’ll get a ride there in 15 minutes or less.
      </p>
    </div>
    <div class="help-item">
      <p><b>What type of vehicle will I ride in?</b></p>
      <p>
        A 4-door sedan. Prior to your ride, we will tell you the vehicle type/color, license plate, and driver name that you should expect.
      </p>
    </div>
    <div class="help-item">
      <p><b>Are rides available in my area?</b></p>
      <p>To check availability in your zip code, visit our website at <b>gogograndparent.com</b> or give us a call.</p>
    </div>
    <div class="help-item">
      <p><b>What are your hours of operation?</b></p>
      <p>You can speak to an operator 24 hours a day, 7 days a week.</p>
      <b><i>24 hours a day, 7 days a week. Including holidays & weekends.</i></b>
    </div>
    <div class="help-item">
      <p><b>And how far can I go?</b></p>
      <p>You can take a trip 100 miles in any direction.</p>
    </div>
    <div class="help-item">
      <p><b>What should I do if I have a question during my ride?</b></p>
      <p>You can call an operator at any time. Just call our number and <b>Press</b> <b>0.</b></p>
    </div>
    <div class="help-item">
      <p><b>Do you pick up at airports?</b></p>
      <p>
        Yes, but depending on the airport there may be a special “pick up location” where you will have to meet our drivers. For most
        airports the operator will be able to help you find your location, but in all airports the driver will be able to tell you where to
        go. You can call your driver at any time by <b>Pressing 3</b>.
      </p>
    </div>
    <div class="help-item">
      <p><b>Are you an emergency medical transportation service?</b></p>
      <p>Lots of folks use us to get to doctor’s appointments but we are no replacement for an ambulance in the event of an emergency.</p>
    </div>
    <div class="help-item">
      <p><b>Are you a non-emergency medical transportation service?</b></p>
      <p>
        No. A lot of people use us to get around, but on demand transportation contractors are not trained to help people that require
        physical assistance and their cars can not be guaranteed to accommodate ambulatory equipment like motorized wheelchairs or scooters.
        Lyft and Uber are curb to curb services and are not good solutions if you require a driver to help you enter or exit the vehicle.
      </p>
    </div>
    <div class="help-item">
      <p><b>How do I deactivate the account?</b></p>
      <p>Please call and ask to speak to a supervisor to deactivate the account.</p>
    </div>
    <div class="help-item">
      <p><b>What are the phone numbers I can call for services?</b></p>
      <p>
        Rides: <b>18554646872</b><br>
        Groceries: <b>18552224919</b><br>
        Gourmet: <b>18557545328</b><br>
        Home Services: <b>18554646771</b><br>
      </p>
    </div>
  </family-page-wrapper>
</template>

<style lang="scss">
.about-gogo {
  .help-item {
    padding-top: 10px;
    margin-top: 10px;
    border-top: 1px solid #c1c1c1;

    &:last-child {
      padding-bottom: 20px;
    }

    p:first-child {
      padding-bottom: 5px;
    }
  }
}
</style>
